import { Link } from 'react-router-dom';

export default function Home() {
  return (
    <div className="space-y-10">
      <div className="bg-white border border-gray-200 shadow-sm p-8 rounded-lg text-center">
        <h1 className="text-3xl font-bold text-blue-600 mb-2">Welcome to Debate Academy</h1>
        <p className="text-gray-600 max-w-xl mx-auto">
          Sharpen your debate skills with AI-assisted practice, structured lessons, and personalized feedback.
        </p>
      </div>

      <div className="grid grid-cols-1 sm:grid-cols-2 gap-6">
        <Link to="/debater" className="block bg-white border border-gray-200 rounded-lg p-6 hover:shadow-md transition">
          <h3 className="text-lg font-semibold text-blue-700 mb-1">AI Debater</h3>
          <p className="text-gray-600 text-sm">
            Engage in real-time debates and receive counter-arguments from an AI opponent.
          </p>
        </Link>

        <Link to="/training" className="block bg-white border border-gray-200 rounded-lg p-6 hover:shadow-md transition">
          <h3 className="text-lg font-semibold text-blue-700 mb-1">Practice Activity</h3>
          <p className="text-gray-600 text-sm">
            Generate motions, build arguments, and get instant feedback on your skills.
          </p>
        </Link>

        <Link to="/modules" className="block bg-white border border-gray-200 rounded-lg p-6 hover:shadow-md transition">
          <h3 className="text-lg font-semibold text-blue-700 mb-1">Lesson Modules</h3>
          <p className="text-gray-600 text-sm">
            Learn debating techniques through interactive lessons, quizzes, and exercises.
          </p>
        </Link>

        <Link to="/modules/my-lessons" className="block bg-white border border-gray-200 rounded-lg p-6 hover:shadow-md transition">
          <h3 className="text-lg font-semibold text-blue-700 mb-1">My Lessons</h3>
          <p className="text-gray-600 text-sm">
            View and access all the lessons you've created or are currently working on.
          </p>
        </Link>
      </div>
    </div>
  );
}
